// Administração → Áreas: nome, descrição, filas do Whaticket de cada área e ativação. A separação por área só
// passa a valer quando uma segunda área de suporte tiver fila (até lá tudo continua na área padrão).
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Chip, FormControlLabel, MenuItem, Paper, Switch, TextField, Typography } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import suporteApi, { mensagemErro } from "../api";

const CartaoArea = ({ a, filas, padrao, onSalvo }) => {
  const [f, setF] = useState({ nome: a.nome, descricao: a.descricao || "", filas: a.filas || [], ativo: a.ativo });
  const salvar = async () => {
    try {
      await suporteApi.put(`/api/areas/${a.codigo}`, f);
      toast.success("Área salva");
      onSalvo();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const nomeFila = (id) => filas.find((q) => q.id === id)?.name || `fila ${id}`;
  return (
    <Paper variant="outlined" style={{ padding: 14, margin: "10px 0", maxWidth: 760 }}>
      <Typography variant="subtitle2">
        {a.codigo} <Chip size="small" label={a.tipo} style={{ marginLeft: 6 }} />{a.codigo === padrao && <Chip size="small" label="padrão" color="primary" style={{ marginLeft: 6 }} />}
      </Typography>
      <TextField size="small" margin="dense" fullWidth label="Nome" value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} />
      <TextField size="small" margin="dense" fullWidth label="Descrição" value={f.descricao} onChange={(e) => setF({ ...f, descricao: e.target.value })} />
      <TextField select size="small" margin="dense" fullWidth label="Filas do Whaticket" SelectProps={{ multiple: true, renderValue: (v) => v.map(nomeFila).join(", ") }}
        value={f.filas} onChange={(e) => setF({ ...f, filas: e.target.value })}>
        {filas.map((q) => <MenuItem key={q.id} value={q.id}>{q.name}</MenuItem>)}
      </TextField>
      <FormControlLabel control={<Switch checked={f.ativo} disabled={a.codigo === padrao} color="primary"
        onChange={(e) => setF({ ...f, ativo: e.target.checked })} />} label={f.ativo ? "Ativa" : "Desativada"} />
      <Button size="small" color="primary" variant="contained" onClick={salvar}>Salvar</Button>
    </Paper>
  );
};

const Areas = () => {
  const [dados, setDados] = useState(null);
  const [filas, setFilas] = useState([]);
  const carregar = useCallback(() => {
    suporteApi.get("/api/areas").then((r) => setDados(r.data)).catch((e) => toast.error(mensagemErro(e)));
  }, []);
  useEffect(() => { carregar(); api.get("/queue").then((r) => setFilas(r.data)).catch(() => {}); }, [carregar]);
  const comFila = (dados?.areas || []).filter((a) => a.tipo === "suporte" && a.ativo && a.filas.length).length;
  return (
    <MainContainer>
      <MainHeader><Title>Áreas</Title></MainHeader>
      <Typography variant="body2" color="textSecondary" style={{ maxWidth: 760 }}>
        {comFila > 1
          ? "Separação por área ligada: cada atendente vê os cards das áreas das suas filas."
          : "Separação por área ainda desligada: enquanto só uma área de suporte tiver fila, todos os cards ficam na área padrão."}
        {" "}Uma fila só pode pertencer a uma área.
      </Typography>
      {dados && dados.areas.map((a) => (
        <CartaoArea key={`${a.codigo}-${(a.filas || []).join(",")}-${a.ativo}`} a={a} filas={filas} padrao={dados.padrao} onSalvo={carregar} />
      ))}
    </MainContainer>
  );
};

export default Areas;
